<template>
    <div class="card app-card">

        <!-- TITLE -->
        <div class="card-header" v-if="title">
            <div class="card-title">
                <strong>{{ title }}</strong>
            </div>
        </div>

        <!-- CUSTOM HEADER -->
        <div class="card-header" v-else-if="hasHeaderContent">
            <slot name="header" />
        </div>

        <slot name="body" v-if="hasBodyContent" />

        <div class="card-footer" v-if="hasFooterContent">
            <slot name="footer" />
        </div>

    </div>
</template>

<script>
import OptionalSlots from '../mixins/OptionalSlotsMixin';

export default {
    mixins: [
        OptionalSlots,
    ],

    props: {
        title: {
            type: String,
            default: null,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/BootstrapCard.vue